import React, {useEffect} from 'react';
import {SelectInput} from '../utils/SelectInput';
import {prepareOptions, responseSelector} from '../utils/utils';
import {equiposGetDuck, equiposGetThunk} from '../equipos/duck';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {log} from '../utils/logs';

export const EquipoSelect = ({
  token,
  equipoOption,
  setEquipoOption,
  onError,
  hint,
}) => {
  const dispatch = useDispatch();

  const equiposGet = useSelector(state => state.equiposGet);

  const [equiposLoadStatus, setEquiposLoadStatus] = useState('IDLE');
  const [equiposOptions, setEquiposOptions] = useState();

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(equiposGet);

    if (error) {
      onError(errorMessage);
      dispatch(equiposGetDuck.actions.clear());
    }

    if (data) {
      log({'equiposGet.useEffect.data': data});

      const mEquiposOptions = prepareOptions(data.items);
      log({mEquiposOptions});

      setEquiposOptions(mEquiposOptions);

      setEquiposLoadStatus('LOADED');
      dispatch(equiposGetDuck.actions.clear());
    }
  }, [equiposGet]);

  useEffect(() => {
    setEquiposLoadStatus('LOADING');
    dispatch(
      equiposGetThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  return (
    <SelectInput
      label="Equipo"
      hint={hint}
      value={equipoOption}
      options={equiposOptions}
      setValue={setEquipoOption}
      disabled={equiposLoadStatus !== 'LOADED'}
      isLoading={equiposLoadStatus !== 'LOADED'}
    />
  );
};
